import React, { useState, useContext } from "react";
import "./ProcessFilter.scss";
import { Checkbox } from "./../Checkbox";
import { ServiceType } from "./../ServiceType";
import { InformativeMessage } from "./../InformativeMessage";
import { Link } from "./../Link";
import { GlobalContext } from "./../Context";

export default function ProcessFilter ({ data, filterState }) {
  const globalContext = useContext(GlobalContext);
  const { activeFilters, addActiveFilter } = globalContext;
  let checkboxes = [];
  let links = [];
  const [hideInformative, setHideInformative] = useState({
    state: true,
    all: false,
  });

  const updateInformativeState = (state, all) => {
    setHideInformative({ state: state, all: all });
  };

  switch (filterState) {
    case "loading":
      return (
        <h2 className="filter-message filter-message--loading">Cargando...</h2>
      );
    case "error":
      return (
        <h2 className="filter-message filter-message--error">
          Ha ocurrido un error, por favor inténtelo de nuevo más tarde
        </h2>
      );
    case "ready":
      if (data && data.filtersByCountry.results[0]) {
        const dataDefined = data.filtersByCountry.results[0];
        dataDefined.fieldServicesList.map((item) => {
          let values = {
            id: item.fieldService && item.fieldService[0] ? item.fieldService[0].tid : null,
            label: item.fieldLabel != null ? item.fieldLabel : "",
            linkTitle: item.fieldLink ? item.fieldLink.title : "",
            linkUri: item.fieldLink ? item.fieldLink.path : "",
          };
          links.push(<Link key={`link-${values.id}`} props={values} />);
          checkboxes.push(
            <Checkbox
              key={values.id}
              props={values}
              addActiveFilter={addActiveFilter}
              activeFilters={activeFilters}
              updateInformativeState={updateInformativeState}
              hideInformative={hideInformative}
            />
          );
        });
        return (
          <fieldset className="process-filter">
            <h4>Busque sucursales y otros servicios</h4>
            <p>
              Ingrese su ubicación para mostrarle las opciones más cercanas o filtre según lo que necesite
            </p>
            <ServiceType data={data} />
            <InformativeMessage
              text={dataDefined.fieldInformativeText ? dataDefined.fieldInformativeText : ""}
              links={links}
            />
          </fieldset>
        );
      }
  }
};
